"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/internal/Observable");
exports.Observable = Observable_1.Observable;
//# sourceMappingURL=Observable.js.map